import React from 'react'
import StaticContent from '@components/StaticContent'
import cx from 'classnames'
import { adStyles } from './adStyles'

/**
 * 文章頁右上欄廣告
 *
 * Ad unit = `BT_a_SB`
 */
export default function PostAsideStickyAd(props) {
  return <StaticContent className={cx('Zi_ad_a_SB', props.className)} css={adStyles} />
}
